
export const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            About Avalar Realty Holdings
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Since our founding in 2024, we have quickly established ourselves at the forefront of luxury real estate development, 
            creating exceptional properties and delivering outstanding returns for our investors.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h3 className="text-3xl font-bold text-slate-900 mb-6">Our Story</h3>
            <div className="space-y-4 text-gray-600">
              <p>
                Founded in 2024, Avalar Realty Holdings began with a vision to transform 
                the luxury real estate landscape through innovative design, strategic locations, 
                and exceptional quality. What started as a boutique development firm has grown 
                into one of the most respected names in the industry.
              </p>
              <p>
                Our commitment to excellence is reflected in every project we undertake. From 
                luxury residential towers to cutting-edge commercial complexes, we focus on 
                creating properties that not only meet market demands but set new standards 
                for quality and innovation.
              </p>
              <p>
                Today, with a portfolio spanning major metropolitan areas, we continue to push 
                boundaries and deliver exceptional value to our clients and investors.
              </p>
            </div>
            
            <div className="mt-8 space-y-4">
              <div className="flex items-center">
                <i className="ri-check-double-line text-teal-600 mr-3"></i>
                <span className="text-gray-700">Award-winning luxury developments</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-double-line text-teal-600 mr-3"></i>
                <span className="text-gray-700">Sustainable building practices</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-double-line text-teal-600 mr-3"></i>
                <span className="text-gray-700">Innovative design solutions</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-double-line text-teal-600 mr-3"></i>
                <span className="text-gray-700">Strategic market positioning</span>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/e977c9f4ca1935bf1b53144827d672c9.jpg"
              alt="Office Interior"
              className="w-full h-96 object-cover object-top rounded-xl shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
